import makeStyles from '@mui/styles/makeStyles';

interface StyleProps {
  variant: string | undefined;
  isInEditMode: boolean;
}

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: ({ isInEditMode }: StyleProps) =>
      isInEditMode ? '100%' : 'fit-content',
  },
  content: {
    alignItems: 'center',
    display: 'flex',

    '&:hover': {
      '& > div > button': {
        visibility: 'visible',
      },
    },
    '& p, a, h5, h6': {
      cursor: 'text',
    },
  },
  iconContainer: {
    position: 'relative',
  },
  editIcon: {
    top: 0,
    right: theme.spacing(-1),
    backgroundColor: theme.palette.common.white,
    visibility: 'hidden',

    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  fontSizeSmall: {
    fontSize: '1.2rem',
  },
  textField: {
    '& > div': {
      '&::before, &::after': {
        content: 'none',
      },
      fontSize: theme.typography.fontSize,
      '& > input': {
        padding: 0,
      },
    },
  },
}));
